module.exports = __webpack_public_path__ + "static/img/newanli-23.33dac70c.jpg";